<template>
    <div class="view solo-view">
        <div class="solo-view-panel">
            <h1>您已登出</h1>
            <div style="text-align:center">
                <router-link :to="{ name: 'login' }">
                    <el-button type="primary" round>重新登入</el-button>
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'LogoutPage',
    data() {
        return {};
    },
    methods: {},
    mounted() {},
};
</script>
<style lang="scss" scoped=""></style>
